import styled from 'styled-components';
// eslint-disable-next-line import/no-namespace
import * as SS from 'styled-system';

export const Container = styled(
  (
    {
      mt,
      mb,
      ml,
      mr,
      mx,
      my,
      pt,
      pb,
      pl,
      pr,
      px,
      py,
      color,
      border,
      borderLeft,
      borderRight,
      borderTop,
      borderBottom,
      borderColor,
      display,
      height,
      width,
      maxWidth,
      verticalAlign,
      ...props
    }: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  ) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div {...props} />
  ),
)`
  ${SS.space} ${SS.color} ${SS.borders} ${SS.borderColor} ${SS.display} 
  ${SS.height} ${SS.width} ${SS.maxWidth} ${SS.verticalAlign};
`;
